@if (items.length > 0) {
  <ul class="list-group-notification">
    @for (item of items; track item.name + '-' + $index; let i = $index) {
      <li class="list-group-notification-item">
        {{ i + 1 }})
        @if (type === 'NO' && openNotificationPopup) {
          <span class="clickable" (click)="onNotificationModalOpen(item)">{{ item.name }}</span>
        } @else {
          {{ item.name }}
        }
        ; {{ item.title }}
      </li>
    }
  </ul>
}
